import { render } from "./UpdateTypeOfDocuments.vue?vue&type=template&id=c166991a"
import script from "./UpdateTypeOfDocuments.vue?vue&type=script&lang=js"
export * from "./UpdateTypeOfDocuments.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__